import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { colors } from '@material-ui/core';

import { 
  Typography, 
  // TextField, 
  // MenuItem,
  Button,
  // IconButton, 
  // FormControlLabel,
  // Radio 
} from '@material-ui/core';


// import DateFnsUtils from '@date-io/date-fns';
// import krLocale from "date-fns/locale/ko";
// import {
//   MuiPickersUtilsProvider,
//   KeyboardTimePicker,
//   KeyboardDatePicker,
// } from '@material-ui/pickers';

// import CloudUploadIcon from '@material-ui/icons/CloudUpload';
// import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

import { SearchInput, StatusBullet } from 'components';

// import { areas, groups } from 'common/datas';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  rowIcons: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    //paddingLeft: theme.spacing(8),
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  // row1: {
  //   width: '240px',
  //   display: 'flex',
  //   alignItems: 'center',
  //   marginLeft: theme.spacing(6),
  //   '& > *': {
  //     marginLeft: theme.spacing(0),
  //     margin: theme.spacing(1),
  //   },
  // },
  // spacer: {
  //   flexGrow: 1
  // },
  // Button: {
  //   marginRight: theme.spacing(1)
  // },
  // exportButton: {
  //   marginRight: theme.spacing(1)
  // },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
}));

const ManageToolbar = props => {
  //const { className, ...rest } = props;

  const { 
    className, 
    type,
    advertises,
    agencies,
    clients,

    onClickFind,

    ...rest
 } = props;

  const classes = useStyles();

  const [findName, setFindName] = useState('');

  useEffect(() => {
    setFindName('');
  }, [type]);

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >

      {(type === 'user' || type === 'area' || type === 'group') && (
          <div className={classes.row}>

            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              {type === 'user' ? '사용자명' : type === 'area' ? '권역명' : '그룹명'}
            </Typography>

            <SearchInput
              className={classes.searchInput}
              placeholder=""
              value={findName}
              onChange={e => setFindName(e.target.value)}
            />
            
            <Button
              color="primary"
              variant="contained"
              onClick={ () => onClickFind(findName) }
            >
              조회
            </Button>

          </div>
        )
      } 

    </div>
  );
};

ManageToolbar.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  companies: PropTypes.array.isRequired,
  agencies: PropTypes.array.isRequired,
  clients: PropTypes.array.isRequired
};

ManageToolbar.defaultProps = {
  companies: [],
  agencies: [],
  clients: []
};

export default ManageToolbar;
